import { call, put } from "redux-saga/effects";
import * as types from "../consts";
import { getCheckout } from "../api";

// -------------------------------PRODUCT-------------------------------------------

export function* getCheckoutSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const checkout: object = yield call(getCheckout, payload);
    yield put({ type: types.POST_CHECKOUT_SUCCESS, response: checkout });
  } catch (error) {
    yield put({ type: types.POST_CHECKOUT_ERROR, error });
  }
}
